import { motion } from 'framer-motion';

const services = [
  {
    icon: 'ri-palette-line',
    title: 'Logo Design',
    description: 'Unique, memorable logos that capture your brand essence',
  },
  {
    icon: 'ri-brush-line',
    title: 'Brand Identity',
    description: 'Complete brand systems with cohesive visual language',
  },
  {
    icon: 'ri-instagram-line',
    title: 'Social Media Creatives',
    description: 'Engaging designs for Instagram, Facebook, and more',
  },
  {
    icon: 'ri-file-paper-line',
    title: 'Posters & Flyers',
    description: 'Eye-catching print and digital promotional materials',
  },
  {
    icon: 'ri-youtube-line',
    title: 'YouTube Thumbnails',
    description: 'Click-worthy thumbnails that boost video views',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'Business Cards & Banners',
    description: 'Professional stationery and marketing materials',
  },
];

export default function LuxuryServicesSection() {
  return (
    <section className="relative py-24 bg-gradient-to-b from-deepBlue to-charcoal overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">
            Premium <span className="gradient-text">Services</span>
          </h2>
          <p className="text-white/70 text-lg font-body max-w-2xl mx-auto">
            Comprehensive design solutions tailored to your needs
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: index * 0.1 }}
              className="glass-panel p-8 rounded-2xl glow-gold smooth-transition hover-lift cursor-pointer"
            >
              <div className="w-14 h-14 rounded-full glass-panel glow-gold flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-gold`}></i>
              </div>
              <h3 className="text-xl font-display font-bold text-white mb-3">
                {service.title}
              </h3>
              <p className="text-white/70 text-sm font-body leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
